module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/for-signing/for-signing.component.html
// module id = ./src/app/components/dashboard/for-signing/for-signing.component.html
// module chunks = main